import { boardStatus } from '../status';
import { KdsTicket, TicketStatus } from '../types/ticket';

/**
 * We need to return active and awaiting tickets or grouped tickets in case they are associated with another active ticket
 * This case will be filtered further in the flow
 */
export const filterActiveAndWaitingBoardTicketsByStatus = (tickets: KdsTicket[]): KdsTicket[] =>
    tickets.filter(({ status, groupingKey }) => groupingKey ?? [...boardStatus, TicketStatus.Waiting].includes(status));
